//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storage } from "../main.js";
export default {
  methods: {
    hoverAction() {
      this.hovering = true;
    },
    stopHoverAction() {
      this.hovering = false;
    },
  },
  data() {
    return {
      thumbnailURL: "",
      hovering: false,
      playerVars: {
        autoplay: 1,
        controls: 0,
        rel: 0,
        modestbranding: 1,
        autohide: 1,
        start: 10,
        end: 30,
        mute: 0,
        playsinline: 1,
      },
    };
  },
  computed: {
    player() {
      return this.hovering ? this.$refs.youtube.player : null;
    },
    thumbnail() {
      return this.classItem.thumbnail ? this.classItem.thumbnail : null;
    },
  },
  mounted() {
    if (this.thumbnail === null) {
      this.thumbnailURL = `https://i.ytimg.com/vi/${this.classItem.YTID}/hqdefault.jpg`;
    } else {
      storage
        .ref(this.thumbnail)
        .getDownloadURL()
        .then((url) => {
          this.thumbnailURL = url;
        });
    }
  },
  props: {
    classItem: {
      default: null,
    },
    instructor: {
      default: null,
    },
  },
};
